<script>
  import LeilaoService from '../../../../domain/leiloes/services/index'
  import { isArray, debounce, uniqBy } from 'lodash'
  import estadosBr from '../../../_default/utils/estados-brasileiros'
  import {VueMaskDirective as mask} from 'v-mask'
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import {VMoney} from 'v-money'

  export default {
    components: {},
    directives: {mask, money: VMoney},
    nome: 'extrato-leilao-form',
    props: {
      extratoId: {
        type: Number
      }
    },
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          placa: null,
          chassi: null,
          observacao: null,
          descricaoLeilao: null,
          dataLeilao: null,
          tipoDocumentoLeiloeiro: 1,
          cpfCnpjLeiloeiro: null,
          tipoDocumentoArrematante: 1,
          cpfCnpjArrematante: null,
          nomeArrematante: null,
          enderecoArrematante: null,
          numeroEndArrematante: null,
          complementoEndArrematante: null,
          bairroEndArrematante: null,
          ufEndArrematante: null,
          codigoMunicipioArrematante: null,
          nomeMunicipioArrematante: null,
          cepEndArrematante: null,
          numeroNotaFiscal: null,
          dataNotaFiscal: null,
          valorNotaFiscal: null,
          renavam: null,
          diarioOficial: null,
          dataDiarioOficial: null
        },
        loadingCidades: false,
        listaCidades: [],
        extratoCadastrado: false
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      },
      cidadesFiltered () {
        const cidades = uniqBy(this.listaCidades, item => item.Codigo)
        return cidades.filter(item => item.Codigo !== 0)
      },
      cidadeSelecionada () {
        return this.listaCidades.find(item => item.Codigo === this.data.codigoMunicipioArrematante)
      }
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          LeilaoService.getExtratoLeilaoInfo(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              this.loadMuncipiosEstado()
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        if (this.extratoId) {
          return
        }
        if (this.loadingCidades) {
          alert('Aguarde, carregando lista de municípios do service DETRO...')
          return
        }
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const data = JSON.parse(JSON.stringify(this.data))
        data.valorNotaFiscal = this.converterParaFormatoN15(data.valorNotaFiscal)
        LeilaoService.cadastrarExtratoLeilao(this.$route.params.id, data)
          .then((response) => {
            let callbackEnd = () => {
              this.$bar.finish()
              this.$loaderOverlay.hide()
              if (this.$route.params.id) {
                this.atualizadoSucesso = true
                this.$el.querySelector('#sucessMsg').focus()
              } else {
                this.atualizadoSucesso = true
              }
              this.extratoCadastrado = true
              this.$emit('finishSubmit')
            }
            callbackEnd()
          }).catch((response) => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            this.cadastroError = response.data.errors
            this.$nextTick(() => {
              this.$refs.error.focus()
            })
            console.log(response)
          })
      },
      loadMuncipiosEstado: debounce(function () {
        this.loadingCidades = true
        this.listaCidades = []
        LeilaoService.getMunicipiosEstadoDetro(this.data.ufEndArrematante)
          .then(response => {
            this.listaCidades = response.data
            this.loadingCidades = false
          })
          .catch(error => {
            this.loadingCidades = false
            alert('Houve um erro ao obter a lista de municípios:\n' + this.printError(error.data.errors))
          })
      }, 500),
      cancel () {
        this.$emit('cancel')
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      converterParaFormatoN15 (str = '') {
        return str.replace(/\D/g, '').padStart(15, '0')
      },
      leiloeiroStandart (cpf = '10935812717') {
        this.data.tipoDocumentoLeiloeiro = 1
        this.data.cpfCnpjLeiloeiro = cpf
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" :style="extratoId ? 'background-color: #f7de69;' : ''" class="content-transition">
      <div class="bg-warning lter b-b wrapper-md" v-if="extratoId">
        <div class="row">
          <div class="col-xs-12">
            <h1 class="font-thin h4 text-black">
              <strong>Atenção</strong><br>
              Este lote já possui um extrato cadastrado. Você está visualizando os dados, não sendo possível alterá-los.
            </h1>
          </div>
        </div>
      </div>
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Extrato de Leilão</h1></div>
          <div class="col-sm-6"></div>
        </div>
      </div>
      <div class="wrapper-sm">
        <div class="panel panel-default" >
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <!--<div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>-->
            <form @submit.prevent.stop="submit" class="form-horizontal" v-if="!extratoCadastrado">

              <div class="form-group">
                <label class="col-sm-4 control-label">Placa</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.placa"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Chassi</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.chassi"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Renavam</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.renavam"/>
                </div>
              </div>

              <div class="clearfix"></div>
              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Observação</label>
                <div class="col-sm-8">
                  <textarea class="form-control" v-model="data.observacao"></textarea>
                </div>
              </div>

              <div class="clearfix"></div>
              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Data do Leilão</label>
                <div class="col-sm-8">
                  <input required type="date" class="form-control" v-model="data.dataLeilao"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Título do Leilão</label>
                <div class="col-sm-8">
                  <textarea required class="form-control" v-model="data.descricaoLeilao"></textarea>
                </div>
              </div>

              <div class="clearfix"></div>
              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo de documento do Leiloeiro</label>
                <div class="col-sm-8">
                  <select required v-model="data.tipoDocumentoLeiloeiro" class="form-control">
                    <option selected="selected" :value="1">CPF</option>
                    <option :value="2">CNPJ</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Documento do Leiloeiro</label>
                <div class="col-sm-8">
                  <input autocomplete="off" required type="text"
                         v-model="data.cpfCnpjLeiloeiro"
                         v-mask="data.tipoDocumentoLeiloeiro === 1 ? '###.###.###-##' : '##.###.###/####-##'"
                         class="form-control"
                  >
                </div>
              </div>

              <div class="clearfix"></div>
              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo de documento do Arrematante</label>
                <div class="col-sm-8">
                  <select required v-model="data.tipoDocumentoArrematante" class="form-control">
                    <option :value="1">CPF</option>
                    <option :value="2">CNPJ</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Documento do Arrematante</label>
                <div class="col-sm-8">
                  <input required autocomplete="off" id="numeroDocumento" type="text"
                         v-model="data.cpfCnpjArrematante"
                         v-mask="data.tipoDocumentoArrematante === 1 ? '###.###.###-##' : '##.###.###/####-##'"
                         class="form-control"
                  >
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome do Arrematante</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.nomeArrematante"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Endereço do Arrematante</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.enderecoArrematante"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Número</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.numeroEndArrematante"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Complemento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.complementoEndArrematante"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Bairro</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.bairroEndArrematante"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">UF</label>
                <div class="col-sm-8">
                  <select required class="form-control" v-model="data.ufEndArrematante" @change="loadMuncipiosEstado">
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Município do Arrematante</label>
                <div class="col-sm-8">
                  <select class="form-control" v-if="loadingCidades" disabled required>
                    <option value=""><i class="fa fa-spinner fa-spin"></i> Carregando...</option>
                  </select>
                  <input required type="text" class="form-control" v-model="data.nomeMunicipioArrematante" v-else-if="extratoId" />
                  <select required class="form-control" v-model="data.codigoMunicipioArrematante" @change="data.nomeMunicipioArrematante = cidadeSelecionada.Nome" v-else>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="cidade.Codigo" v-for="cidade in cidadesFiltered" :key="cidade.Codigo">{{cidade.Nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">CEP</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-mask="'##.###-###'" v-model="data.cepEndArrematante"/>
                </div>
              </div>

              <div class="clearfix"></div>
              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Número da Nota Fiscal</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.numeroNotaFiscal"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Data da Nota Fiscal</label>
                <div class="col-sm-8">
                  <input required type="date" class="form-control" v-model="data.dataNotaFiscal"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Valor da Nota Fiscal</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.valorNotaFiscal" v-money="money" />
                </div>
              </div>

              <div class="clearfix"></div>
              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Número do Diário Oficial</label>
                <div class="col-sm-8">
                  <input required type="text" class="form-control" v-model="data.diarioOficial"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Data do Diário Oficial</label>
                <div class="col-sm-8">
                  <input required type="date" class="form-control" v-model="data.dataDiarioOficial"/>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper" v-if="!extratoId">
                <u-button type="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="cancel">Cancelar</u-button>
              </div>
            </form>
            <transition name="slide" v-if="extratoCadastrado">
              <div class="content-transition">
                <div class="wrapper">
                  <div class="row">
                    <div class="col-sm-12 text-center">
                      <h1><i class="fa fa-check-circle text-success" style="font-size: 150px;"></i></h1>
                      <h3>Extrato cadastrado!</h3>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// ExtratoLeilaoForm.vue?6c24ed5a